// extracted by mini-css-extract-plugin
export var errorIcon = "_q4-1";
export var nameLogo = "_q4-0";